var WarmupQuestions = require("lib/academic/WarmupQuestions");

class NonFictionArgumentsQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[NonFictionArgumentsQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [SPECIFIC_ENTITY_STAGE];
		}

		if (!answers[SPECIFIC_ENTITY]) {
			return [SPECIFIC_ENTITY_STAGE];
		}

		if (!answers[POINT_SUBJECT] || !answers[POINT_VERB] || !answers[POINT_PREDICATE]) {
			return [POINT_STAGE];
		}

		if (this.props.level == "1") {
			return [POINT_STAGE, true];
		}

		if (!answers[EVIDENCE_SUBJECT] || !answers[EVIDENCE_VERB] || !answers[EVIDENCE_PREDICATE]) {
			return [EVIDENCE_STAGE];
		}

		if (this.props.level == "2") {
			return [EVIDENCE_STAGE, true];
		}

		if (!answers[EVIDENCE_TYPE]) {
			return [EVIDENCE_TYPE_STAGE];
		}

		return [EVIDENCE_TYPE_STAGE, true];
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var specificEntityDisplay = (
			<div>
				{ this.props.getTextF("label1", SPECIFIC_ENTITY_STAGE) }
				{ this.props.renderInputF(SPECIFIC_ENTITY) }
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0) {
			var specificEntity = this.props.answers[NonFictionArgumentsQuestion.STEM][SPECIFIC_ENTITY];
			var replacementsHash = {};
			replacementsHash[WarmupQuestions.SPECIFIC_ENTITY] = specificEntity;

			var pointDisplay = (
				<div>
					{ this.props.getTextF("label1", POINT_STAGE, replacementsHash) }
					{ this.props.renderDropdownF("choices1", POINT_STAGE, POINT_SUBJECT) }
					{ this.props.renderDropdownF("choices2", POINT_STAGE, POINT_VERB) }
					{ this.props.renderInputF(POINT_PREDICATE) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1) {
			var evidenceDisplay = (
				<div>
					{ this.props.getTextF("label1", EVIDENCE_STAGE) }
					{ this.props.renderDropdownF("choices1", EVIDENCE_STAGE, EVIDENCE_SUBJECT) }
					{ this.props.renderDropdownF("choices2", EVIDENCE_STAGE, EVIDENCE_VERB) }
					{ this.props.renderInputF(EVIDENCE_PREDICATE) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 2) {
			var evidenceTypeDisplay = (
				<div>
					{ this.props.getTextF("label1", EVIDENCE_TYPE_STAGE) }
					{ this.props.renderDropdownF("choices1", EVIDENCE_TYPE_STAGE, EVIDENCE_TYPE) }.
				</div>
			);
		}

		return (
			<div>
				{ specificEntityDisplay }
				{ pointDisplay }
				{ evidenceDisplay }
				{ evidenceTypeDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

NonFictionArgumentsQuestion.STEM = "nfarg";

// stages
var SPECIFIC_ENTITY_STAGE = "specificentity";
var POINT_STAGE = "point";
var EVIDENCE_STAGE = "evidence";
var EVIDENCE_TYPE_STAGE = "evidencetype";

var STAGES = [
	SPECIFIC_ENTITY_STAGE, POINT_STAGE, EVIDENCE_STAGE, EVIDENCE_TYPE_STAGE
];

// answer keys
var SPECIFIC_ENTITY = "specific_entity";
var POINT_SUBJECT = "point_subject";
var POINT_VERB = "point_verb";
var POINT_PREDICATE = "point_predicate";
var EVIDENCE_SUBJECT = "evidence_subject";
var EVIDENCE_VERB = "evidence_verb";
var EVIDENCE_PREDICATE = "evidence_predicate";
var EVIDENCE_TYPE = "evidence_type";

NonFictionArgumentsQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = NonFictionArgumentsQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/NonFictionArgumentsQuestion.js